import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { HyperLinkMenu } from "@models/hyperLinkMenu";
import { deleteRequest, fetchRequest } from "@actions/hyperLinkMenu";
import HyperLinkMenusTable from "@components/hyperLinkMenus/Table";
import { Button, Card, Col, Input, Row, Modal } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import { FormattedMessage } from "react-intl";
import { getHyperLinkMenusList } from "@reducers/hyperLinkMenu";
import SearchHyperLinkMenusComponent from "@components/hyperLinkMenus/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: HyperLinkMenu[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class HyperLinkMenusIndexPage extends React.Component<AllProps> {
  deleteHyperLinkMenu = (item: HyperLinkMenu): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/hyperLinkMenus/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.new_hyperLinkMenu"
                defaultMessage={`Create HyperLinkMenu`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header search-part`} bordered={false}>
            <SearchHyperLinkMenusComponent search={search} />
          </Card>
          <HyperLinkMenusTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteHyperLinkMenu}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ hyperLinkMenus }: ApplicationState) => ({
  loading: hyperLinkMenus.loading,
  data: getHyperLinkMenusList(hyperLinkMenus),
  count: hyperLinkMenus.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(HyperLinkMenusIndexPage));
